module.exports = __webpack_public_path__ + "static/img/logo_skoltech_eng.f5ac047.png";


//////////////////
// WEBPACK FOOTER
// ./site/deeptensor/assets/pictures/logo_skoltech_eng.png
// module id = AmdL
// module chunks = 8